import React, { useState, useEffect } from "react";
import _ from "lodash";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { Segment, Grid, Dropdown, Input, Container, Form, Button, Label, Icon, Divider, Checkbox, Card, Modal, Dimmer, Loader, Table } from "semantic-ui-react";
import { toast } from "react-toastify";
import { Storage } from 'aws-amplify';
import { MapModal } from './MapModal';
import FuseCollapsiblePanel from '../../../components/generic/FuseCollapsiblePanel';

import * as KML_ACTIONS from '../../../actions/kmlUploadActions';
import * as CV_SEARCH_ACTIONS from "../../../actions/cvSearchActions";

export function CVSearch(props) {
    const [downloadingCV, setDownloadingCV] = useState(false);
    const [formatOptions, setFormatOptions] = useState(null);
    const [pendingDownload, setPendingDownload] = useState(null);
    const [state, setState] = useState({
        languages: [],
        qualifications: [],
        searchTerms: [],
        incomeStreams: [],
        fileLocationType: false,
        selectedSection: null,
        locationRadius: {
            location: {
                latitude: "",
                longitude: "",
            },
            radius: "5",
        },
    });

    const [searchTerm, setSearchTerm] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [sectionModalOpen, setSectionModalOpen] = useState(false);
    const [selectedSectionDetails, setSelectedSectionDetails] = useState(null);
    const [lookupModalOpen, setLookupModalOpen] = useState(false);
    const [lookupValues, setLookupValues] = useState([]);
    const [mapModalOpen, setMapModalOpen] = useState(false);
    const [selectedCV, setSelectedCV] = useState(null);
    const [cvSearchQuery, setcvSearchQuery] = useState(null);
    const [loading, setLoading] = useState(false);

    const {
        handleSubmit,
    } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
    });

    useEffect(() => {
        if (!_.isEmpty(props.tenant)) {
            props.fetchKmlFilesAction(props.tenant);
            props.fetchSkillsQnaire(props.baseTenant);
        }
    }, [props.tenant]);

    const onSubmit = async () => {
        let payload = {}

        payload["fileLocationType"] = state.fileLocationType ? true : false
        if (state.qualifications.length !== 0)
            payload["qualifications"] = state.qualifications
        if (state.languages.length !== 0)
            payload["languages"] = state.languages

        if (!_.isEmpty(state.searchTerms)) {
            payload["terms"] = state.searchTerms;
        }

        if (
            (state.locationRadius.location.latitude !== '' && state.locationRadius.location.longitude !== '') ||
            (state.locationRadius.location.type === 'KMLFILE' && state.locationRadius.radius !== '')
        ) {
            payload["locationRadius"] = state.locationRadius;
        }


        if (_.isEmpty(payload.qualifications) && _.isEmpty(payload.languages) && _.isEmpty(payload.incomeStreams) && _.isEmpty(payload.terms) && _.isEmpty(payload.locationRadius)) {
            toast.warning("Please fill in some of the filters to help with the search process. Remember to add the term.")
            return
        }
        await props.cvSearchAction(payload, props.tenant, setLoading)
        setcvSearchQuery(payload);
    };

    const handleAddSearchTerm = (e) => {
        e.preventDefault();

        if (searchTerm.trim() !== "") {

            setState(prevState => ({
                ...prevState,
                searchTerms: [...prevState.searchTerms, searchTerm.trim()]
            }));

            setSearchTerm("");
        }
    };

    const handleDeleteSearchTerm = (index) => {
        setState(prevState => ({
            ...prevState,
            searchTerms: prevState.searchTerms.filter((_, i) => i !== index)
        }));
    };

    const handleLanguagesChange = (e, { value }) => {
        setState(prevState => ({
            ...prevState,
            languages: value
        }));
    };

    const handleQualificationsChange = (e, { value }) => {
        setState(prevState => ({
            ...prevState,
            qualifications: value
        }));
    };

    const handleLookupSectionChange = (e, { value }) => {
        if (value === "none") {
            setState((prevState) => ({
                ...prevState,
                selectedSection: value,
            }));
            return;
        }

        setState((prevState) => ({
            ...prevState,
            selectedSection: value,
        }));

        openSectionModal(value);
    };

    const openSectionModal = (sectionId) => {
        const sectionQuestions = props.questions.filter(
            (question) => question.sectionId === sectionId
        );

        setSelectedSectionDetails({
            section: props.sections.find((section) => section.id === sectionId),
            questions: sectionQuestions,
        });

        setSectionModalOpen(true);
    };

    const closeSectionModal = () => {
        setSelectedSectionDetails(null);
        setSectionModalOpen(false);
        setState((prevState) => ({
            ...prevState,
            selectedSection: null,
        }));
    };

    const handleQuestionClick = (question) => {
        const lookup = props.lookup.find((item) => item.id === question.lookupId);

        if (lookup && lookup.values) {
            setLookupValues(JSON.parse(lookup.values));
            setLookupModalOpen(true);
        }
    };

    const openModal = (cv) => {
        props.fetchSelectedCVAction(cv, props.tenant, setLoading);
        props.checkCVOwnStatusAction(props.tenant, cv);
        setSelectedCV(cv);
        setModalOpen(true);
    };

    const closeModal = () => {
        setSelectedCV(null);
        setModalOpen(false);
        props.clearUserCV();
    };

    const handleMapSelect = (coordinates) => {
        if (coordinates) {
            const { lat, lng } = coordinates;
            setState((prevState) => ({
                ...prevState,
                locationRadius: {
                    ...prevState.locationRadius,
                    location: {
                        latitude: lat.toString(),
                        longitude: lng.toString()
                    }
                }
            }));
            setMapModalOpen(false);
        }
    };

    const qualificationOptions = [
        { key: uuidv4(), text: "NQF 1 / Grade 9", value: "NQF 1 / Grade 9" },
        { key: uuidv4(), text: "NQF 2 / Grade 10", value: "NQF 2 / Grade 10" },
        { key: uuidv4(), text: "NQF 3 / Grade 11", value: "NQF 3 / Grade 11" },
        { key: uuidv4(), text: "NQF 4 / Grade 12", value: "NQF 4 / Grade 12" },
        { key: uuidv4(), text: "NQF 5 / Higher Certificate", value: "NQF 5 / Higher Certificate" },
        { key: uuidv4(), text: "NQF 6 / Advanced Certificate or National Diploma", value: "NQF 6 / Advanced Certificate or National Diploma" },
        { key: uuidv4(), text: "NQF 7 / Advanced Diploma or Bachelor's Degree", value: "NQF 7 / Advanced Diploma or Bachelor's Degree" },
        { key: uuidv4(), text: "NQF 8 / Postgraduate Certificate or Honour's Degree", value: "NQF 8 / Postgraduate Certificate or Honour's Degree" },
        { key: uuidv4(), text: "NQF 9 / Master's Degree", value: "NQF 9 / Master's Degree" },
        { key: uuidv4(), text: "NQF 10 / Doctoral Degree", value: "NQF 10 / Doctoral Degree" }
    ];

    const languagesOptions = [
        { key: uuidv4(), text: "Zulu", value: "Zulu" },
        { key: uuidv4(), text: "Afrikaans", value: "Afrikaans" },
        { key: uuidv4(), text: "English", value: "English" },
        { key: uuidv4(), text: "Southern Sotho", value: "Southern Sotho" },
        { key: uuidv4(), text: "Swati", value: "Swati" },
        { key: uuidv4(), text: "Tswana", value: "Tswana" },
        { key: uuidv4(), text: "Northern Sotho", value: "Northern Sotho" },
        { key: uuidv4(), text: "Ndebele", value: "Ndebele" },
        { key: uuidv4(), text: "Xhosa", value: "Xhosa" },
        { key: uuidv4(), text: "Tsonga", value: "Tsonga" },
        { key: uuidv4(), text: "SA Sign Language", value: "SA Sign Language" }
    ];

    const sectionOptions = [
        { key: "none", text: "None", value: "none" },
        ...props.sections
            ?.filter((section) =>
                props.questions.some((question) => question.sectionId === section.id)
            )
            .sort((a, b) => a.sequence - b.sequence)
            .map((section) => ({
                key: section.id,
                text: section.name,
                value: section.id,
            })),
    ];

    const _buildSearch = () => {

        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column width={8}>
                        <Form.Field>
                            <label>Add Terms To Search For:</label>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Input
                                    placeholder='Enter Terms'
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <Button icon='plus' className='success' onClick={handleAddSearchTerm} style={{ marginLeft: '10px' }} />
                            </div>
                        </Form.Field>
                        <Form.Field>
                            <label>Search Terms:</label>
                            {state.searchTerms.length > 0 &&
                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    {state.searchTerms.map((term, index) => (
                                        <div key={index} style={{ marginRight: '10px', marginBottom: '5px' }}>
                                            <Label>
                                                {term}
                                                <Icon name='delete' onClick={() => handleDeleteSearchTerm(index)} />
                                            </Label>
                                        </div>
                                    ))}
                                </div>
                            }
                        </Form.Field>
                    </Grid.Column>
                    <Grid.Column width={6}>
                        <Form.Field>
                            <label>Question Lookups:</label>
                            <Dropdown
                                placeholder='Select Lookup Values'
                                fluid
                                search
                                selection
                                options={sectionOptions}
                                onChange={handleLookupSectionChange}
                                value={state.selectedSection}
                            />
                        </Form.Field>
                        {/* <Form.Field>
                            <label>Qualifications:</label>
                            <Dropdown
                                placeholder='Select Qualifications'
                                fluid
                                multiple
                                search
                                selection
                                options={qualificationOptions}
                                onChange={handleQualificationsChange}
                                value={state.qualifications}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Languages:</label>
                            <Dropdown
                                placeholder='Select Languages'
                                fluid
                                multiple
                                search
                                selection
                                options={languagesOptions}
                                onChange={handleLanguagesChange}
                                value={state.languages}
                            />
                        </Form.Field> */}
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={3}>
                        <Form.Field>
                            <label>Coordinate Or File:</label>
                            <Checkbox
                                style={{ paddingTop: '10px' }}
                                label="Select File"
                                toggle
                                checked={state.fileLocationType}
                                onChange={() => {
                                    setState(prevState => ({
                                        ...prevState,
                                        fileLocationType: !prevState.fileLocationType
                                    }));
                                }}
                            />
                        </Form.Field>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        {state.fileLocationType === false ? (
                            <Form.Field>
                                <label>Location:</label>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Input
                                        style={{ paddingRight: '10px' }}
                                        type="number"
                                        icon="map marker"
                                        placeholder="Latitude..."
                                        value={state.locationRadius.location.latitude}
                                        onChange={(event, { value }) => {
                                            if (value >= -90 && value <= 90) {
                                                setState(prevState => ({
                                                    ...prevState,
                                                    locationRadius: {
                                                        ...prevState.locationRadius,
                                                        location: {
                                                            ...prevState.locationRadius.location,
                                                            latitude: value
                                                        }
                                                    }
                                                }));
                                            } else {
                                                toast.warning("Invalid Coordinate! * Latitude should be between -90 and 90.");
                                            }
                                        }}
                                    />
                                    <Input
                                        type="number"
                                        icon="map marker"
                                        placeholder="Longitude..."
                                        value={state.locationRadius.location.longitude}
                                        onChange={(event, { value }) => {
                                            if (value >= -180 && value <= 180) {
                                                setState(prevState => ({
                                                    ...prevState,
                                                    locationRadius: {
                                                        ...prevState.locationRadius,
                                                        location: {
                                                            ...prevState.locationRadius.location,
                                                            longitude: value
                                                        }
                                                    }
                                                }));
                                            } else {
                                                toast.warning("Invalid Coordinate! * Longitude should be between -180 and 180.");
                                            }
                                        }}
                                    />
                                    <Button
                                        icon="map"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setMapModalOpen(true);
                                        }}
                                        style={{ marginLeft: '10px' }}
                                    >
                                        Map
                                    </Button>
                                </div>
                            </Form.Field>
                        ) : (
                            <Form.Field>
                                <label>File:</label>
                                <Dropdown
                                    placeholder="Select File"
                                    fluid
                                    selection
                                    search
                                    options={
                                        [...props.kmlFiles]
                                            .sort((a, b) => a.name.localeCompare(b.name))
                                            .map(file => ({
                                                key: file.id,
                                                text: file.name,
                                                value: file
                                            }))
                                    }
                                    onChange={(event, data) => {
                                        const selectedFile = data.value;
                                        setState(prevState => ({
                                            ...prevState,
                                            locationRadius: {
                                                ...prevState.locationRadius,
                                                location: selectedFile
                                            }
                                        }));
                                    }}
                                />
                            </Form.Field>
                        )}
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <Form.Field>
                            <label>Radius (KM):</label>
                            <Input
                                type="number"
                                icon="map"
                                placeholder="Radius..."
                                value={state.locationRadius.radius}
                                onChange={(event, { value }) => {
                                    setState(prevState => ({
                                        ...prevState,
                                        locationRadius: {
                                            ...prevState.locationRadius,
                                            radius: value
                                        }
                                    }));
                                }}
                            />
                        </Form.Field>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    };

    const renderSectionModal = () => {
        if (!selectedSectionDetails) return null;

        const { section, questions } = selectedSectionDetails;

        return (
            <Modal open={sectionModalOpen} onClose={closeSectionModal} size="large">
                <Modal.Header>{section?.name} - Questions</Modal.Header>
                <Modal.Content>
                    {questions.length > 0 ? (
                        questions.map((question, index) => (
                            <div key={question.id} style={{ marginBottom: "10px" }}>
                                <Table celled>
                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Cell style={{ width: "80%" }}>
                                                {question.question}
                                            </Table.Cell>
                                            <Table.Cell style={{ width: "20%", textAlign: "center" }}>
                                                <Button
                                                    style={{ backgroundColor: "#3A95A4", color: "white" }}
                                                    onClick={() => handleQuestionClick(question)}
                                                >
                                                    Select
                                                </Button>
                                            </Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>
                            </div>
                        ))
                    ) : (
                        <p>No questions available for this section.</p>
                    )}
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={closeSectionModal} className="warning">
                        Close
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    };

    const renderQuestionLookupModal = () => {
        return (
            <Modal open={lookupModalOpen} onClose={() => setLookupModalOpen(false)} size="small">
                <Modal.Header>Select Lookup Values</Modal.Header>
                <Modal.Content>
                    {lookupValues.length > 0 ? (
                        <Table celled>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Value</Table.HeaderCell>
                                    <Table.HeaderCell style={{ textAlign: "center" }}>Add/Remove</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {lookupValues.map((item, index) => {
                                    const isSelected = state.searchTerms.includes(item.value);
                                    return (
                                        <Table.Row key={index}>
                                            <Table.Cell>{item.value}</Table.Cell>
                                            <Table.Cell style={{ textAlign: "center" }}>
                                                <Checkbox
                                                    // type="checkbox"
                                                    checked={isSelected}
                                                    onChange={() => {
                                                        if (isSelected) {
                                                            // Remove the value from searchTerms
                                                            setState((prevState) => ({
                                                                ...prevState,
                                                                searchTerms: prevState.searchTerms.filter(
                                                                    (term) => term !== item.value
                                                                ),
                                                            }));
                                                            toast.warning(`Removed "${item.value}" from search terms.`);
                                                        } else {
                                                            // Add the value to searchTerms
                                                            setState((prevState) => ({
                                                                ...prevState,
                                                                searchTerms: [...prevState.searchTerms, item.value],
                                                            }));
                                                            toast.success(`Added "${item.value}" to search terms.`);
                                                        }
                                                    }}
                                                />
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                })}
                            </Table.Body>
                        </Table>
                    ) : (
                        <p>No lookup values available.</p>
                    )}
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => setLookupModalOpen(false)} className="warning">
                        Close
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    };


    const _buildCVBoard = () => {
        const { cv } = props;

        if (_.isEmpty(cv.data)) {
            return (
                <Segment style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                    <Icon name="search" size="huge" />
                    <Label style={{ marginTop: '10px', textAlign: 'center' }}>Perform a search to view potential CVs</Label>
                </Segment>
            );
        }


        const renderCards = () => {
            // Sort the cv.data array by _score in descending order
            const sortedCvData = cv.data.sort((a, b) => b._score - a._score);

            return sortedCvData.map((cvItem, index) => {
                let percentage = Math.round(((cvItem._score - 0) / (1 - 0)) * 100 / 5) * 5;

                percentage = Math.min(Math.max(0, percentage), 100);

                let headerColor;
                if (percentage === 100) {
                    headerColor = '#3A95A4';
                } else if (percentage > 80) {
                    headerColor = 'green';
                } else if (percentage > 50) {
                    headerColor = '#FFA500';
                } else {
                    headerColor = 'red';
                }

                return (
                    <Grid.Column key={cvItem._id} style={{ padding: '10px' }}>
                        <Card onClick={() => openModal(cvItem)}>
                            <Card.Content>
                                <Card.Header style={{ paddingBottom: "10px" }}>
                                    <span style={{
                                        backgroundColor: headerColor,
                                        color: 'white',
                                        borderRadius: '50%',
                                        padding: '8px',
                                    }}>{percentage}% </span>
                                </Card.Header>
                                <Card.Meta>Match based on search query.</Card.Meta>
                            </Card.Content>
                            <Card.Content extra>
                                CV ~ {index + 1}
                            </Card.Content>
                        </Card>
                    </Grid.Column>
                );
            });
        };


        return (
            <div>
                {loading && (
                    <Dimmer active inverted>
                        <Loader>Loading...</Loader>
                    </Dimmer>
                )}
                <Segment>
                    <Grid columns={4}>
                        <Grid.Row>
                            {renderCards()}
                        </Grid.Row>
                    </Grid>
                    {renderCVModal()}
                </Segment>
            </div>
        );
    };

    const downloadFile = async (fileKey, fileExt) => {
        try {
            const s3Key = fileKey.replace(/^public\//, "");
            const signedUrl = await Storage.get(s3Key);
            const response = await fetch(signedUrl);

            if (!response.ok) throw new Error("Failed to fetch the file");

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `CV_${Date.now()}.${fileExt}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            toast.success("CV downloaded successfully");
        } catch (error) {
            console.error("Error downloading CV:", error.message);
            toast.error(`Failed to download CV: ${error.message}`);
        } finally {
            setDownloadingCV(false);
        }
    };

    const handleFormatSelect = (format) => {
        if (!pendingDownload) return;
        const fileKey = pendingDownload[format];
        setFormatOptions(null);
        setPendingDownload(null);
        downloadFile(fileKey, format);
    };

    const handleDownloadCV = async (cv) => {
        try {
            setDownloadingCV(true);
            const result = await props.downloadCVAction(cv);

            if (result.userQnaire === null) {
                toast.warning("User CV details unavailable. The user might have chosen to delete his personal information.");
                setDownloadingCV(false);
                return;
            }

            if (!result.userDoc || !result.userDoc.key) {
                toast.error("No document found for download");
                setDownloadingCV(false);
                return;
            }

            let fileKey;
            let fileExt;
            const key = result.userDoc.key;

            if (typeof key === 'object') {
                const available = Object.keys(key).filter(k => key[k]);
                if (available.length > 1) {
                    setFormatOptions(available);
                    setPendingDownload(key);
                    setDownloadingCV(false);
                    return;
                } else if (available.length === 1) {
                    fileKey = key[available[0]];
                    fileExt = available[0];
                }
            } else if (typeof key === 'string') {
                fileKey = key;
                fileExt = key.split('.').pop();
            }

            if (!fileKey) {
                toast.error("No downloadable file found");
                setDownloadingCV(false);
                return;
            }

            await downloadFile(fileKey, fileExt);
        } catch (error) {
            console.error("Error downloading CV:", error.message);
            toast.error(`Failed to download CV: ${error.message}`);
            setDownloadingCV(false);
        }
    };

    const renderCVModal = () => {
        if (!selectedCV || !props.userCV?.length > 0) return null;

        const { cvMainSections, cvSubSections, cvQuestions, boughtCv, userAnswers } = props;
        const isCVBought = boughtCv.length > 0;

        // Filter out sections where all questions do not have answers
        const filteredSections = cvMainSections.filter((section) => {
            const subSectionIds = cvSubSections?.filter(sub => sub.parentSectionId === section.id).map(sub => sub.id) || [];
            const sectionIds = [section.id, ...subSectionIds];
            return cvQuestions.some(
                (question) =>
                    sectionIds.includes(question.sectionId) &&
                    userAnswers.some((answer) => answer.questionId === question.id)
            );
        });

        return (
            <Modal open={modalOpen} onClose={closeModal} size="large">
                <Modal.Header>User Details:</Modal.Header>
                <Modal.Content>
                    {filteredSections
                        .sort((a, b) => a.sequence - b.sequence)
                        .map((section, index) => (
                            <div key={section.id}>
                                <FuseCollapsiblePanel
                                    content={_buildQuestionList(section, section.name)}
                                    isCollapsed={true}
                                    leadingIcon="book"
                                    trailingIcon="angle down"
                                    header={section.name}
                                />
                                {index !== cvMainSections.length - 1 && (
                                    <div style={{ marginBottom: "10px" }}></div>
                                )}
                            </div>
                        ))}
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        className="success"
                        loading={downloadingCV}
                        disabled={downloadingCV}
                        onClick={(e) => {
                            e.preventDefault();
                            handleDownloadCV(selectedCV);
                        }}
                    >
                        <Icon name="download" />
                        {downloadingCV ? "Downloading..." : "Download CV"}
                    </Button>
                    {/* Original Purchase CV button - temporarily replaced with Download
                    <Button
                        className="success"
                        loading={loading}
                        disabled={isCVBought}
                        onClick={(e) => {
                            e.preventDefault();
                            if (!isCVBought) {
                                props.purchaseCVAction(selectedCV, cvSearchQuery, setLoading);
                                closeModal();
                            }
                        }}
                    >
                        {isCVBought ? "CV already owned" : "Purchase CV"}
                    </Button>
                    */}
                    <Button onClick={closeModal} className="warning">
                        Close
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    };

    const _buildQuestionList = (section, sectionName) => {
        const { cvQuestions, cvSubSections, userAnswers } = props;

        const subsections = cvSubSections.filter(
            (subsection) =>
                subsection.parentSectionId === section.id &&
                cvQuestions.some(
                    (question) =>
                        question.sectionId === subsection.id &&
                        userAnswers.some((answer) => answer.questionId === question.id)
                )
        );

        const sectionQuestions = cvQuestions.filter(
            (question) =>
                question.sectionId === section.id &&
                userAnswers.some((answer) => answer.questionId === question.id)
        );

        let combinedQuestionAnswers = sectionQuestions.flatMap((question) => {
            const relatedAnswers = userAnswers.filter(
                (answer) => answer.questionId === question.id && answer.values
            );

            return relatedAnswers.length > 0
                ? relatedAnswers.map((answer) => ({
                    question,
                    answer,
                }))
                : [{ question, answer: null }];
        });

        // Updated sorting logic
        combinedQuestionAnswers.sort((a, b) => {
            const repeatGroupA = a.answer?.repeatGroup;
            const repeatGroupB = b.answer?.repeatGroup;

            // If both items have repeatGroup, sort by repeatGroup first
            if (repeatGroupA && repeatGroupB) {
                if (repeatGroupA !== repeatGroupB) {
                    return repeatGroupA - repeatGroupB;
                }
                return a.question.sequence - b.question.sequence;
            }

            // If only one of the items has repeatGroup, place the one without repeatGroup later
            if (!repeatGroupA && repeatGroupB) {
                return 1;  // Place b before a
            } else if (repeatGroupA && !repeatGroupB) {
                return -1; // Place a before b
            }

            // If neither has repeatGroup, just sort by sequence
            return a.question.sequence - b.question.sequence;
        });


        if (sectionQuestions.length === 0 && subsections.length === 0) {
            return null;
        }

        return (
            <div>
                {combinedQuestionAnswers.map(({ question, answer }, index) => (
                    <div key={`${question.id}-${index}`}>
                        <Table celled>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell style={{ width: "90%" }}>
                                        Q: {question.question}
                                    </Table.Cell>
                                </Table.Row>
                                {answer ? (
                                    <Table.Row>
                                        <Table.Cell
                                            style={{
                                                width: "90%",
                                                backgroundColor:
                                                    question.questionType !== "upload_image"
                                                        ? "#b7e0b5"
                                                        : "transparent",
                                            }}
                                        >
                                            A: {answer.values}
                                        </Table.Cell>
                                    </Table.Row>
                                ) : (
                                    <Table.Row>
                                        <Table.Cell
                                            style={{ width: "90%", backgroundColor: "#e0e0e0" }}
                                        >
                                            No answer provided.
                                        </Table.Cell>
                                    </Table.Row>
                                )}
                            </Table.Body>
                        </Table>
                        {index !== combinedQuestionAnswers.length - 1 && (
                            <div style={{ marginBottom: "10px" }}></div>
                        )}
                    </div>
                ))}

                <div style={{ marginBottom: "10px" }}></div>

                {subsections.map((subsection, index) => (
                    <div key={subsection.id}>
                        <FuseCollapsiblePanel
                            key={subsection.id}
                            content={_buildQuestionList(subsection, subsection.name)}
                            isCollapsed={true}
                            leadingIcon="book"
                            trailingIcon="angle down"
                            header={subsection.name}
                        />
                        {index !== subsections.length - 1 && (
                            <div style={{ marginBottom: "10px" }}></div>
                        )}
                    </div>
                ))}
            </div>
        );
    };


    return (
        <Container fluid>
            <h3>CV Search:</h3>
            <Segment>
                <Form
                    size="medium"
                    onSubmit={handleSubmit(onSubmit)}
                    style={{ paddingBottom: "25px" }}
                >
                    {_buildSearch()}
                    <MapModal
                        open={mapModalOpen}
                        onClose={() => setMapModalOpen(false)}
                        onSelectCoordinates={handleMapSelect}
                        selectedPos={state.locationRadius.location}
                    />
                    <Divider />
                    <Button.Group floated="right">
                        <Button type="submit" className="success" loading={loading}>
                            <Icon name="checkmark" /> Search
                        </Button>
                    </Button.Group>
                </Form>
            </Segment>

            {renderSectionModal()}
            {renderQuestionLookupModal()}
            {_buildCVBoard()}

            <Modal size="tiny" open={!!formatOptions} onClose={() => { setFormatOptions(null); setPendingDownload(null); }}>
                <Modal.Header>Select Download Format</Modal.Header>
                <Modal.Content>
                    <p>This CV is available in multiple formats. Please select one:</p>
                    <Button.Group fluid vertical>
                        {formatOptions && formatOptions.map(fmt => (
                            <Button key={fmt} primary style={{ marginBottom: '5px' }} onClick={() => handleFormatSelect(fmt)}>
                                {fmt.toUpperCase()}
                            </Button>
                        ))}
                    </Button.Group>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => { setFormatOptions(null); setPendingDownload(null); }}>Cancel</Button>
                </Modal.Actions>
            </Modal>
        </Container>
        //
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        cv: state.cvSearch.cvSearch,
        userCV: state.cvSearch.userCV,
        tenant: state.tenantManagement.activeTenant,
        baseTenant: state.tenantManagement.sourceTenant,
        kmlFiles: state.kmlFiles,
        //Skills Qnaire Details 
        sections: state.activationRules.sections,
        questions: state.activationRules.questions.filter(item => item.op !== 'd' && (item.questionType === 'multi_select' || item.questionType === 'mc_sel_one')),
        lookup: state.lookups,
        //CV Details
        boughtCv: state.cvSearch.boughtCV,
        cvMainSections: state.cvSearch.userCV?.filter(item => item.type === 'SECTION' && !item.parentSectionId),
        cvSubSections: state.cvSearch.userCV?.filter(item => item.type === 'SECTION' && item.parentSectionId),
        cvQuestions: state.cvSearch.userCV?.filter(item => item.type === 'QUESTION' && item.questionType !== "no_answer" && item.isPersonalInfo !== true && item.whatsAppOnly !== true),
        userAnswers: state.cvSearch.userCVAnswers.filter(item => item.type === 'ANSWER'),
    };
}

export default connect(
    // map state to props
    mapStateToProps,
    // map dispatch to props
    (dispatch) => ({
        cvSearchAction: (payload, tenant, setLoading) => dispatch(CV_SEARCH_ACTIONS.cvSearchAction(payload, tenant, setLoading)),
        fetchKmlFilesAction: (tenant) => dispatch(KML_ACTIONS.fetchKmlFilesAction(tenant)),
        fetchSkillsQnaire: (tenant) => dispatch(CV_SEARCH_ACTIONS.fetchSkillsQnaire(tenant)),
        fetchSelectedCVAction: (cv, tenant, setLoading) => dispatch(CV_SEARCH_ACTIONS.fetchSelectedCVAction(cv, tenant, setLoading)),
        checkCVOwnStatusAction: (tenant, cv) => dispatch(CV_SEARCH_ACTIONS.checkCVOwnStatusAction(tenant, cv)),
        purchaseCVAction: (cv, cvSearchQuery, setLoading) => dispatch(CV_SEARCH_ACTIONS.purchaseCVAction(cv, cvSearchQuery, setLoading)),
        downloadCVAction: (cv) => dispatch(CV_SEARCH_ACTIONS.downloadCVFromSearchAction(cv)),
        clearUserCV: () => dispatch(CV_SEARCH_ACTIONS.clearUserCV()),
    })
)(CVSearch);
